// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__6ODWI","header":"MessagesList_header__3BVct","chat":"MessagesList_chat__1llIi"};